import { Card, CardBody, Col, Row } from "reactstrap";

import CountUp from "react-countup";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";

import { useParams } from "react-router-dom";

export default function Summary() {
  const dispatch = useDispatch();
  const params = useParams();

  const { GetSubscriptionList } = useSelector((state) => ({
    GetSubscriptionList:
      state.ManageLicense.licensesSubscriptionList?.subscriptionlicence_list,
  }));
  const [latestInvoiceDate, setLatestInvoiceDate] = useState("");

  useEffect(() => {
    // go trough the list of invoices and get the latest date invoice CreatedDateTime
    if (isEmpty(GetSubscriptionList)) return;
    // first  sort the list by date
    let sortedList = GetSubscriptionList.sort(
        (a, b) => new Date(b.CreatedDateTime) - new Date(a.CreatedDateTime)
      ),
      // then get the first item
      latestDate = sortedList[0]?.CreatedDateTime;
    // set the latest date
    setLatestInvoiceDate(latestDate);
  }, [GetSubscriptionList]);

  const [licensesMonthlyCost, setLicensesMonthlyCost] = useState(0);
  const [licensesYearlyCost, setLicensesYearlyCost] = useState(0);
  const [totalLicenses, setTotalLicenses] = useState(0);
  useEffect(() => {
    if (isEmpty(GetSubscriptionList)) return;

    setLicensesMonthlyCost(
      // first filter EndDateTime < today
      GetSubscriptionList?.filter(
        (item) =>
          item?.SubscriptionLicenceDurationType_Name === "Monthly" &&
          !item?.EndDateTime // check if item?.EndDateTime is empty
            ? true
            : new Date(item?.EndDateTime) > new Date() // check if item?.EndDateTime is not empty and the date is in the future
      )?.reduce(
        (total, item) =>
          Number(total) +
          (item?.SubscriptionLicenceDurationType_Name === "Monthly" &&
            +Number(item?.AmountLocalSubTotal)),
        0
      )
    );

    setLicensesYearlyCost(
      GetSubscriptionList?.filter(
        (item) =>
          item?.SubscriptionLicenceDurationType_Name === "Yearly" &&
          !item?.EndDateTime // check if item?.EndDateTime is empty
            ? true
            : new Date(item?.EndDateTime) > new Date() // check if item?.EndDateTime is not empty and the date is in the future
      )?.reduce(
        (total, item) =>
          Number(total) +
          (item?.SubscriptionLicenceDurationType_Name === "Yearly" &&
            +Number(item?.AmountLocalSubTotal)),
        0
      )
    );
    // Total Active Licenses
    setTotalLicenses(
      GetSubscriptionList?.reduce(
        (total, item) =>
          Number(total) +
          // check if item?.RenewalDateTime is not empty and the date is in the future
          (item?.RenewalDateTime &&
            new Date(item?.RenewalDateTime) > new Date() &&
            +1),
        0
      )
    );
  }, [GetSubscriptionList]);

  const [summaryBox, setSummaryBox] = useState([
    {
      id: 2,
      label: "License Monthly Cost",
      badge: "ri-arrow-up-circle-line text-success",
      icon: "fa-solid fa-calendar-check",
      counter: Number(licensesMonthlyCost),
      decimals: 2,
      suffix: "",
      prefix: "£",
    },
    {
      id: 1,
      label: "Licenses Yearly Cost",
      badge: "ri-arrow-down-circle-line text-danger",
      icon: "ri-exchange-funds-line",
      counter: Number(licensesYearlyCost),
      decimals: 2,
      suffix: "",
      prefix: "£",
    },

    {
      id: 3,
      label: "Total Active Licenses",
      badge: "ri-arrow-up-circle-line text-success",
      icon: "fa-regular fa-id-badge",
      counter: Number(totalLicenses),
      decimals: 0,
      suffix: "",
      prefix: " ",
    },
  ]);

  useEffect(() => {
    if (isEmpty(GetSubscriptionList)) return;
    let temp = [...summaryBox];
    temp[0].counter = Number(licensesMonthlyCost);
    temp[1].counter = Number(licensesYearlyCost);
    temp[2].counter = Number(totalLicenses);
    setSummaryBox(temp);
  }, [
    GetSubscriptionList,
    licensesMonthlyCost,
    licensesYearlyCost,
    totalLicenses,
  ]);

  return (
    <>
      <Row>
        <Col>
          <Row className="row-cols-md-3 row-cols-1">
            {(summaryBox || []).map((item, key) => (
              <Col
                className={item.id === 4 ? "col-lg" : "col-lg border-end"}
                key={key}
              >
                <div className="mt-3 mt-md-0 py-4 px-3">
                  <h5 className="text-muted text-uppercase fs-13">
                    {item.label}{" "}
                    <i
                      className={"fs-18 float-end align-middle " + item.badge}
                    ></i>
                  </h5>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                      <i className={"display-6 text-muted " + item.icon}></i>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <h2 className="mb-0">
                        <span className="counter-value">
                          {item.counter && (
                            <CountUp
                              start={0}
                              prefix={item.prefix}
                              suffix={item.suffix}
                              separator={item.separator}
                              end={item.counter}
                              decimals={item.decimals}
                              duration={2}
                            />
                          )}
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
}
